// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 2C17.52 2 22 6.48 22 12S17.52 22 12 22 2 17.52 2 12 6.48 2 12 2M16.21 13.87A1 1 0 0 0 14.8 13.86 3.98 3.98 0 0 1 12 15 3.98 3.98 0 0 1 9.2 13.86 1 1 0 0 0 7.8 15.29 6 6 0 0 0 12 17 6 6 0 0 0 16.2 15.28 1 1 0 0 0 16.21 13.87M8.5 8A1.5 1.5 0 1 0 8.5 11 1.5 1.5 0 0 0 8.5 8M15.5 8A1.5 1.5 0 1 0 15.5 11 1.5 1.5 0 0 0 15.5 8"/>';

/** Emoji (communication). */
const icon: IconData = {
  id: "emoji",
  name: "Emoji",
  category: "communication",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M9 9.5A.5.5 0 1 1 8 9.5.5.5 0 0 1 9 9.5M16 9.5A.5.5 0 1 1 15 9.5.5.5 0 0 1 16 9.5"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.5 14.57A4.98 4.98 0 0 0 12 16 4.98 4.98 0 0 0 15.5 14.57M21 12A9 9 0 1 1 3 12 9 9 0 0 1 21 12ZM9 9.5A.5.5 0 1 1 8 9.5.5.5 0 0 1 9 9.5ZM16 9.5A.5.5 0 1 1 15 9.5.5.5 0 0 1 16 9.5Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M11.9 2L14.11 2.23 15.98 2.83 17.67 3.77 19.14 5 20.34 6.49 21.25 8.2 21.81 10.09 22 12.1 21.77 14.11 21.17 15.98 20.23 17.67 19 19.14 17.51 20.34 15.8 21.25 13.91 21.81 11.9 22 9.89 21.77 8.02 21.17 6.33 20.23 4.87 19 3.66 17.51 2.75 15.8 2.19 13.91 2 11.9 2.23 9.89 2.83 8.02 3.77 6.33 5 4.87 6.49 3.66 8.2 2.75 10.09 2.19Z"/></g><path d="M9 9.5A.5.5 0 1 1 8 9.5.5.5 0 0 1 9 9.5M16 9.5A.5.5 0 1 1 15 9.5.5.5 0 0 1 16 9.5"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.5 14.57A4.98 4.98 0 0 0 12 16 4.98 4.98 0 0 0 15.5 14.57M21 12A9 9 0 1 1 3 12 9 9 0 0 1 21 12ZM9 9.5A.5.5 0 1 1 8 9.5.5.5 0 0 1 9 9.5ZM16 9.5A.5.5 0 1 1 15 9.5.5.5 0 0 1 16 9.5Z"/>',
    },
  },
  animation: () => import("../animations/emoji.js"),
};

export default icon;
